// proto/v2/execution/execution.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file execution/execution.proto (package lvdr.v2.execution, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { CostInfo, CreditInfo, LocalizedCopy, ProgressInfo } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file execution/execution.proto.
 */
export const file_execution_execution: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_common]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.execution.StartExecutionRequest
 */
export type StartExecutionRequest = Message<"lvdr.v2.execution.StartExecutionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.StartExecutionRequest.
 * Use `create(StartExecutionRequestSchema)` to create a new message.
 */
export const StartExecutionRequestSchema: GenMessage<StartExecutionRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 0);

/**
 * @generated from message lvdr.v2.execution.PauseExecutionRequest
 */
export type PauseExecutionRequest = Message<"lvdr.v2.execution.PauseExecutionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.PauseExecutionRequest.
 * Use `create(PauseExecutionRequestSchema)` to create a new message.
 */
export const PauseExecutionRequestSchema: GenMessage<PauseExecutionRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 1);

/**
 * @generated from message lvdr.v2.execution.ResumeExecutionRequest
 */
export type ResumeExecutionRequest = Message<"lvdr.v2.execution.ResumeExecutionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.ResumeExecutionRequest.
 * Use `create(ResumeExecutionRequestSchema)` to create a new message.
 */
export const ResumeExecutionRequestSchema: GenMessage<ResumeExecutionRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 2);

/**
 * @generated from message lvdr.v2.execution.CancelExecutionRequest
 */
export type CancelExecutionRequest = Message<"lvdr.v2.execution.CancelExecutionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.CancelExecutionRequest.
 * Use `create(CancelExecutionRequestSchema)` to create a new message.
 */
export const CancelExecutionRequestSchema: GenMessage<CancelExecutionRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 3);

/**
 * @generated from message lvdr.v2.execution.RestartExecutionRequest
 */
export type RestartExecutionRequest = Message<"lvdr.v2.execution.RestartExecutionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.RestartExecutionRequest.
 * Use `create(RestartExecutionRequestSchema)` to create a new message.
 */
export const RestartExecutionRequestSchema: GenMessage<RestartExecutionRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 4);

/**
 * @generated from message lvdr.v2.execution.RetryExecutionRequest
 */
export type RetryExecutionRequest = Message<"lvdr.v2.execution.RetryExecutionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.RetryExecutionRequest.
 * Use `create(RetryExecutionRequestSchema)` to create a new message.
 */
export const RetryExecutionRequestSchema: GenMessage<RetryExecutionRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 5);

/**
 * @generated from message lvdr.v2.execution.ReAggregateRequest
 */
export type ReAggregateRequest = Message<"lvdr.v2.execution.ReAggregateRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.execution.ReAggregateRequest.
 * Use `create(ReAggregateRequestSchema)` to create a new message.
 */
export const ReAggregateRequestSchema: GenMessage<ReAggregateRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 6);

/**
 * @generated from message lvdr.v2.execution.MarkNodesForRetryRequest
 */
export type MarkNodesForRetryRequest = Message<"lvdr.v2.execution.MarkNodesForRetryRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated string node_ids = 2;
   */
  nodeIds: string[];
};

/**
 * Describes the message lvdr.v2.execution.MarkNodesForRetryRequest.
 * Use `create(MarkNodesForRetryRequestSchema)` to create a new message.
 */
export const MarkNodesForRetryRequestSchema: GenMessage<MarkNodesForRetryRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 7);

/**
 * @generated from message lvdr.v2.execution.GetRetryPlanRequest
 */
export type GetRetryPlanRequest = Message<"lvdr.v2.execution.GetRetryPlanRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.GetRetryPlanRequest.
 * Use `create(GetRetryPlanRequestSchema)` to create a new message.
 */
export const GetRetryPlanRequestSchema: GenMessage<GetRetryPlanRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 8);

/**
 * @generated from message lvdr.v2.execution.ExecuteRetryPlanRequest
 */
export type ExecuteRetryPlanRequest = Message<"lvdr.v2.execution.ExecuteRetryPlanRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;
};

/**
 * Describes the message lvdr.v2.execution.ExecuteRetryPlanRequest.
 * Use `create(ExecuteRetryPlanRequestSchema)` to create a new message.
 */
export const ExecuteRetryPlanRequestSchema: GenMessage<ExecuteRetryPlanRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 9);

/**
 * Responses
 *
 * @generated from message lvdr.v2.execution.MarkNodesForRetryResponse
 */
export type MarkNodesForRetryResponse = Message<"lvdr.v2.execution.MarkNodesForRetryResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated string marked_node_ids = 2;
   */
  markedNodeIds: string[];
};

/**
 * Describes the message lvdr.v2.execution.MarkNodesForRetryResponse.
 * Use `create(MarkNodesForRetryResponseSchema)` to create a new message.
 */
export const MarkNodesForRetryResponseSchema: GenMessage<MarkNodesForRetryResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 10);

/**
 * @generated from message lvdr.v2.execution.RetryPlanResponse
 */
export type RetryPlanResponse = Message<"lvdr.v2.execution.RetryPlanResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * @generated from field: repeated lvdr.v2.execution.RetryNode nodes = 3;
   */
  nodes: RetryNode[];
};

/**
 * Describes the message lvdr.v2.execution.RetryPlanResponse.
 * Use `create(RetryPlanResponseSchema)` to create a new message.
 */
export const RetryPlanResponseSchema: GenMessage<RetryPlanResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 11);

/**
 * @generated from message lvdr.v2.execution.RetryNode
 */
export type RetryNode = Message<"lvdr.v2.execution.RetryNode"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string goal = 2;
   */
  goal: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.execution.RetryNode.
 * Use `create(RetryNodeSchema)` to create a new message.
 */
export const RetryNodeSchema: GenMessage<RetryNode> = /*@__PURE__*/
  messageDesc(file_execution_execution, 12);

/**
 * Events
 *
 * @generated from message lvdr.v2.execution.ExecutionStartedEvent
 */
export type ExecutionStartedEvent = Message<"lvdr.v2.execution.ExecutionStartedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionStartedEvent.
 * Use `create(ExecutionStartedEventSchema)` to create a new message.
 */
export const ExecutionStartedEventSchema: GenMessage<ExecutionStartedEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 13);

/**
 * @generated from message lvdr.v2.execution.ExecutionProgressEvent
 */
export type ExecutionProgressEvent = Message<"lvdr.v2.execution.ExecutionProgressEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: lvdr.v2.common.ProgressInfo progress = 2;
   */
  progress?: ProgressInfo | undefined;

  /**
   * @generated from field: lvdr.v2.common.CostInfo cost = 3;
   */
  cost?: CostInfo | undefined;

  /**
   * Live credit picture. Previously EstimatedCredits and BudgetTerminated were
   * computed by the engine on every metrics tick and then dropped at this
   * boundary, so the frontend could never show a cap, a percentage, or why a
   * run stopped growing.
   *
   * @generated from field: lvdr.v2.common.CreditInfo credits = 4;
   */
  credits?: CreditInfo | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionProgressEvent.
 * Use `create(ExecutionProgressEventSchema)` to create a new message.
 */
export const ExecutionProgressEventSchema: GenMessage<ExecutionProgressEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 14);

/**
 * @generated from message lvdr.v2.execution.ExecutionCompletedEvent
 */
export type ExecutionCompletedEvent = Message<"lvdr.v2.execution.ExecutionCompletedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: lvdr.v2.common.CostInfo total_cost = 3;
   */
  totalCost?: CostInfo | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionCompletedEvent.
 * Use `create(ExecutionCompletedEventSchema)` to create a new message.
 */
export const ExecutionCompletedEventSchema: GenMessage<ExecutionCompletedEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 15);

/**
 * @generated from message lvdr.v2.execution.ExecutionFailedEvent
 */
export type ExecutionFailedEvent = Message<"lvdr.v2.execution.ExecutionFailedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 3;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: lvdr.v2.execution.ResearchFailureSummary failure_summary = 4;
   */
  failureSummary?: ResearchFailureSummary | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionFailedEvent.
 * Use `create(ExecutionFailedEventSchema)` to create a new message.
 */
export const ExecutionFailedEventSchema: GenMessage<ExecutionFailedEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 16);

/**
 * @generated from message lvdr.v2.execution.ExecutionPausedEvent
 */
export type ExecutionPausedEvent = Message<"lvdr.v2.execution.ExecutionPausedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionPausedEvent.
 * Use `create(ExecutionPausedEventSchema)` to create a new message.
 */
export const ExecutionPausedEventSchema: GenMessage<ExecutionPausedEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 17);

/**
 * @generated from message lvdr.v2.execution.ExecutionCancelledEvent
 */
export type ExecutionCancelledEvent = Message<"lvdr.v2.execution.ExecutionCancelledEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionCancelledEvent.
 * Use `create(ExecutionCancelledEventSchema)` to create a new message.
 */
export const ExecutionCancelledEventSchema: GenMessage<ExecutionCancelledEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 18);

/**
 * @generated from message lvdr.v2.execution.ExecutionActivityEvent
 */
export type ExecutionActivityEvent = Message<"lvdr.v2.execution.ExecutionActivityEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string activity_type = 3;
   */
  activityType: string;

  /**
   * @generated from field: string detail = 4;
   */
  detail: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp | undefined;

  /**
   * CHAT-43c: the localisable form of `detail`, for node_progress. The client renders
   * this and falls back to `detail` when absent (an older backend). A CURRENT backend
   * leaves `detail` EMPTY for node_progress — web/messages/*.json is the only English.
   *
   * @generated from field: lvdr.v2.common.LocalizedCopy detail_copy = 6;
   */
  detailCopy?: LocalizedCopy | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ExecutionActivityEvent.
 * Use `create(ExecutionActivityEventSchema)` to create a new message.
 */
export const ExecutionActivityEventSchema: GenMessage<ExecutionActivityEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 19);

/**
 * @generated from message lvdr.v2.execution.DelayNotificationEvent
 */
export type DelayNotificationEvent = Message<"lvdr.v2.execution.DelayNotificationEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: int32 estimated_seconds = 4;
   */
  estimatedSeconds: number;
};

/**
 * Describes the message lvdr.v2.execution.DelayNotificationEvent.
 * Use `create(DelayNotificationEventSchema)` to create a new message.
 */
export const DelayNotificationEventSchema: GenMessage<DelayNotificationEvent> = /*@__PURE__*/
  messageDesc(file_execution_execution, 20);

/**
 * Failure catalog messages
 *
 * @generated from message lvdr.v2.execution.ResearchFailureSummary
 */
export type ResearchFailureSummary = Message<"lvdr.v2.execution.ResearchFailureSummary"> & {
  /**
   * @generated from field: string tier = 1;
   */
  tier: string;

  /**
   * @generated from field: string primary_category = 2;
   */
  primaryCategory: string;

  /**
   * @generated from field: int32 total_nodes = 3;
   */
  totalNodes: number;

  /**
   * @generated from field: int32 completed_nodes = 4;
   */
  completedNodes: number;

  /**
   * @generated from field: int32 failed_nodes = 5;
   */
  failedNodes: number;

  /**
   * @generated from field: repeated lvdr.v2.execution.NodeFailureInfo failed_details = 6;
   */
  failedDetails: NodeFailureInfo[];

  /**
   * @generated from field: string user_message = 7;
   */
  userMessage: string;

  /**
   * @generated from field: string user_hint = 8;
   */
  userHint: string;

  /**
   * @generated from field: repeated lvdr.v2.execution.RecoveryAction actions = 9;
   */
  actions: RecoveryAction[];

  /**
   * @generated from field: string circuit_breaker_reason = 10;
   */
  circuitBreakerReason: string;

  /**
   * primary_cause explains WHY a run failed even when failed_nodes == 0 (e.g. the
   * assembler aborted on placeholder sections). Derived from graph facts, NOT from
   * per-node failures. Empty for runs whose cause is fully captured by failed_details.
   * (field 11 here is unrelated to ResearchResultResponse.failure_summary=11 in research.proto)
   *
   * @generated from field: lvdr.v2.execution.ResearchFailureCause primary_cause = 11;
   */
  primaryCause?: ResearchFailureCause | undefined;
};

/**
 * Describes the message lvdr.v2.execution.ResearchFailureSummary.
 * Use `create(ResearchFailureSummarySchema)` to create a new message.
 */
export const ResearchFailureSummarySchema: GenMessage<ResearchFailureSummary> = /*@__PURE__*/
  messageDesc(file_execution_execution, 21);

/**
 * @generated from message lvdr.v2.execution.NodeFailureInfo
 */
export type NodeFailureInfo = Message<"lvdr.v2.execution.NodeFailureInfo"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string agent_name = 2;
   */
  agentName: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * English for a humanised error (the fallback), else the raw error text,
   * which the criteria-HITL affordance parses. Never replaced by a key.
   *
   * @generated from field: string error = 4;
   */
  error: string;

  /**
   * Stable humanErrorMap code (internal/domain NodeErrorCode*, lowercase snake).
   * Empty means `error` is the raw text. The web client localises the line by
   * this code; `error` is the English fallback.
   *
   * @generated from field: string error_code = 5;
   */
  errorCode: string;
};

/**
 * Describes the message lvdr.v2.execution.NodeFailureInfo.
 * Use `create(NodeFailureInfoSchema)` to create a new message.
 */
export const NodeFailureInfoSchema: GenMessage<NodeFailureInfo> = /*@__PURE__*/
  messageDesc(file_execution_execution, 22);

/**
 * ResearchFailureCause is a structured, causal explanation of a research failure.
 * stage/code are stable strings pinned by internal/domain constants (not proto enums)
 * so the frontend can localize by `code`; human_summary is an English fallback.
 *
 * @generated from message lvdr.v2.execution.ResearchFailureCause
 */
export type ResearchFailureCause = Message<"lvdr.v2.execution.ResearchFailureCause"> & {
  /**
   * grounding|indexing|retrieval|synthesis|assembly
   *
   * @generated from field: string stage = 1;
   */
  stage: string;

  /**
   * e.g. EMBEDDING_BACKEND_DEGRADED, EMPTY_CHUNKSTORE, PLACEHOLDER_SECTIONS
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * plain-language English fallback (FE localizes by code)
   *
   * @generated from field: string human_summary = 3;
   */
  humanSummary: string;

  /**
   * ordered machine facts justifying the cause
   *
   * @generated from field: repeated lvdr.v2.execution.FailureEvidence evidence = 4;
   */
  evidence: FailureEvidence[];
};

/**
 * Describes the message lvdr.v2.execution.ResearchFailureCause.
 * Use `create(ResearchFailureCauseSchema)` to create a new message.
 */
export const ResearchFailureCauseSchema: GenMessage<ResearchFailureCause> = /*@__PURE__*/
  messageDesc(file_execution_execution, 23);

/**
 * FailureEvidence is one machine fact backing a ResearchFailureCause, e.g.
 * {key:"pages_indexed", label:"Pages indexed", value:"0"}.
 *
 * @generated from message lvdr.v2.execution.FailureEvidence
 */
export type FailureEvidence = Message<"lvdr.v2.execution.FailureEvidence"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message lvdr.v2.execution.FailureEvidence.
 * Use `create(FailureEvidenceSchema)` to create a new message.
 */
export const FailureEvidenceSchema: GenMessage<FailureEvidence> = /*@__PURE__*/
  messageDesc(file_execution_execution, 24);

/**
 * @generated from message lvdr.v2.execution.RecoveryAction
 */
export type RecoveryAction = Message<"lvdr.v2.execution.RecoveryAction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool primary = 4;
   */
  primary: boolean;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;
};

/**
 * Describes the message lvdr.v2.execution.RecoveryAction.
 * Use `create(RecoveryActionSchema)` to create a new message.
 */
export const RecoveryActionSchema: GenMessage<RecoveryAction> = /*@__PURE__*/
  messageDesc(file_execution_execution, 25);

/**
 * @generated from message lvdr.v2.execution.DismissResearchErrorRequest
 */
export type DismissResearchErrorRequest = Message<"lvdr.v2.execution.DismissResearchErrorRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.DismissResearchErrorRequest.
 * Use `create(DismissResearchErrorRequestSchema)` to create a new message.
 */
export const DismissResearchErrorRequestSchema: GenMessage<DismissResearchErrorRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 26);

/**
 * @generated from message lvdr.v2.execution.DismissResearchErrorResponse
 */
export type DismissResearchErrorResponse = Message<"lvdr.v2.execution.DismissResearchErrorResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message lvdr.v2.execution.DismissResearchErrorResponse.
 * Use `create(DismissResearchErrorResponseSchema)` to create a new message.
 */
export const DismissResearchErrorResponseSchema: GenMessage<DismissResearchErrorResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 27);

/**
 * @generated from message lvdr.v2.execution.UpdateResearchBudgetRequest
 */
export type UpdateResearchBudgetRequest = Message<"lvdr.v2.execution.UpdateResearchBudgetRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 additional_budget = 2;
   */
  additionalBudget: number;
};

/**
 * Describes the message lvdr.v2.execution.UpdateResearchBudgetRequest.
 * Use `create(UpdateResearchBudgetRequestSchema)` to create a new message.
 */
export const UpdateResearchBudgetRequestSchema: GenMessage<UpdateResearchBudgetRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 28);

/**
 * @generated from message lvdr.v2.execution.UpdateResearchBudgetResponse
 */
export type UpdateResearchBudgetResponse = Message<"lvdr.v2.execution.UpdateResearchBudgetResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int32 new_total_budget = 2;
   */
  newTotalBudget: number;
};

/**
 * Describes the message lvdr.v2.execution.UpdateResearchBudgetResponse.
 * Use `create(UpdateResearchBudgetResponseSchema)` to create a new message.
 */
export const UpdateResearchBudgetResponseSchema: GenMessage<UpdateResearchBudgetResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 29);

/**
 * RaiseCreditCeilingRequest raises a RUNNING research's credit ceiling mid-run.
 *
 * Distinct from UpdateResearchBudgetRequest above, which mutates the legacy
 * Config.BudgetLimit, never reaches the live coordinator, and is failure-only.
 * This one reaches Coordinator.RaiseCreditCeiling and can resume a run that
 * wound down on its cap.
 *
 * @generated from message lvdr.v2.execution.RaiseCreditCeilingRequest
 */
export type RaiseCreditCeilingRequest = Message<"lvdr.v2.execution.RaiseCreditCeilingRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int64 additional_credits = 2;
   */
  additionalCredits: bigint;
};

/**
 * Describes the message lvdr.v2.execution.RaiseCreditCeilingRequest.
 * Use `create(RaiseCreditCeilingRequestSchema)` to create a new message.
 */
export const RaiseCreditCeilingRequestSchema: GenMessage<RaiseCreditCeilingRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 30);

/**
 * @generated from message lvdr.v2.execution.RaiseCreditCeilingResponse
 */
export type RaiseCreditCeilingResponse = Message<"lvdr.v2.execution.RaiseCreditCeilingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int64 new_ceiling = 2;
   */
  newCeiling: bigint;

  /**
   * @generated from field: string error = 3;
   */
  error: string;
};

/**
 * Describes the message lvdr.v2.execution.RaiseCreditCeilingResponse.
 * Use `create(RaiseCreditCeilingResponseSchema)` to create a new message.
 */
export const RaiseCreditCeilingResponseSchema: GenMessage<RaiseCreditCeilingResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 31);

/**
 * @generated from message lvdr.v2.execution.IgnoreFailedNodesRequest
 */
export type IgnoreFailedNodesRequest = Message<"lvdr.v2.execution.IgnoreFailedNodesRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated string node_ids = 2;
   */
  nodeIds: string[];

  /**
   * @generated from field: bool reaggregate = 3;
   */
  reaggregate: boolean;
};

/**
 * Describes the message lvdr.v2.execution.IgnoreFailedNodesRequest.
 * Use `create(IgnoreFailedNodesRequestSchema)` to create a new message.
 */
export const IgnoreFailedNodesRequestSchema: GenMessage<IgnoreFailedNodesRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 32);

/**
 * @generated from message lvdr.v2.execution.IgnoreFailedNodesResponse
 */
export type IgnoreFailedNodesResponse = Message<"lvdr.v2.execution.IgnoreFailedNodesResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: repeated string skipped_node_ids = 2;
   */
  skippedNodeIds: string[];
};

/**
 * Describes the message lvdr.v2.execution.IgnoreFailedNodesResponse.
 * Use `create(IgnoreFailedNodesResponseSchema)` to create a new message.
 */
export const IgnoreFailedNodesResponseSchema: GenMessage<IgnoreFailedNodesResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 33);

/**
 * @generated from message lvdr.v2.execution.StartOverRequest
 */
export type StartOverRequest = Message<"lvdr.v2.execution.StartOverRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.execution.StartOverRequest.
 * Use `create(StartOverRequestSchema)` to create a new message.
 */
export const StartOverRequestSchema: GenMessage<StartOverRequest> = /*@__PURE__*/
  messageDesc(file_execution_execution, 34);

/**
 * @generated from message lvdr.v2.execution.StartOverResponse
 */
export type StartOverResponse = Message<"lvdr.v2.execution.StartOverResponse"> & {
  /**
   * @generated from field: string new_research_id = 1;
   */
  newResearchId: string;
};

/**
 * Describes the message lvdr.v2.execution.StartOverResponse.
 * Use `create(StartOverResponseSchema)` to create a new message.
 */
export const StartOverResponseSchema: GenMessage<StartOverResponse> = /*@__PURE__*/
  messageDesc(file_execution_execution, 35);

